<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(dominio.nome) }}</div>
    <div class="panel-body panel_info">
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          id="botaoEditar"
          data-test-id="link-botaoeditar"
          :to="'/dominio/cadastro/' + dominio._id"
          name="botaoEditar"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  props: {
    dominio: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
